import React from 'react';
import { t } from '../../../../../../modules/infra/i18n';

const Notes = ({ survivingCustomer, duplicates, cellClassName }) => (
  <div className="c-table-card__row c-table-card__row--bordered">
    <div className="c-table-card__cell u-2/12">
      <div>{t('customers:duplicates.notes_label')}</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">{t('customers:duplicates.notes_after_merge')}</div>
      <div>{survivingCustomer.notes}</div>
    </div>
    {
      duplicates.map(d => (
        <div key={d.id} className={cellClassName}>
          {d.notes}
        </div>
      ))
    }
  </div>
);

export default Notes;
